/**
 * Formulaire de contact
 * Traitements avant envoi
 */

console.log("contactform");

try {
  const form = document.querySelector("form");
  const inputCtrl = document.querySelector("input[name=ctrl]");
  inputCtrl.value = "";

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const tempformData = new FormData(form);
    const formData = Object.fromEntries(tempformData.entries());
    if (formEstValide(formData)) {
      const inputCtrl = document.querySelector("input[name=ctrl]");
      inputCtrl.value = "jsValidated";
      form.submit();
    }
  });
} catch (e) {}

const formEstValide = (formData) => {
  let errors = [];
  const ulError = document.querySelector("#error");
  if (
    !formData.demande ||
    !formData.email ||
    !formData.localite ||
    !formData.nom ||
    !formData.prenom ||
    !formData.tel
  ) {
    errors.push("Vous avez laissé des champs vides !");
  } else if (formData.ctrl) {
    errors.push("Erreur lors de l'envoi ! Veuillez réessayer !");
  } else {
    console.log(errors.length);
    errors = [];
  }
  if (errors.length) {
    let errorHtml = "";
    errors.forEach((e) => {
      errorHtml += `<li>${e}<li>`;
    });
    ulError.innerHTML = errorHtml;
    errors = [];
    return false;
  } else {
    ulError.innerHTML = "";
    return true;
  }
};
